export const constants = {
  authTypes: {
    tm: "tm",
    register: "register",
  },
  authOrigins: {
    purchasePlan: "purchasePlan",
    groupInvitePurchase: "groupInvitePurchase",
    groupInviteLogin: "groupInviteLogin",
    swafPromptGetStart: "swafPromptGetStart",
    landingRegistrationCard: "landingRegistrationCard",
    general: "general",
    passGroupCard: "passGroupCard",
    marketplaceEventsPage: "marketplaceEventsPage",
    marketplaceCreateListingPage: "marketplaceCreateListingPage",
    marketplaceListingPage: "marketplaceListingPage",
    redeemGift: "redeemGift",
  },
  checkoutTabs: {
    auth: "auth",
    checkout: "checkout",
    go: "go",
  },
  storage: {
    session: "@ss-fanhub-session-storage",
    // Sales-rep attribution captured from the landing URL. Kept in two entries
    // because they are captured independently: info fields need per-team config
    // to know which Archtics slot each query param maps to, the rep account id
    // does not.
    attributionInfoFields: "@ss-fanhub-attribution-info-fields",
    attributionRepAccount: "@ss-fanhub-attribution-rep-account",
  },
  // How long a rep link keeps applying. Note this lifespan is written into each
  // stored entry at capture time, so changing it only affects links clicked
  // after the change — anyone already carrying attribution keeps the window
  // they were captured under until they click a rep link again.
  attributionTtlMs: 1000 * 60 * 60 * 24 * 7,  // 1 week — attribution survives a multi-visit buying journey
  // Archtics acct_rep_id ceiling. Enforced at capture so an oversized value
  // from a junk or tampered link is never stored or sent — rep attribution must
  // never be able to block a checkout.
  attributionRepAccountIdMaxLength: 64,
  // Machine-readable error codes returned by the API. Needed because the
  // messages are team-configurable and every error shares statusCode 400.
  apiErrorCodes: {
    marketplaceAccountGroupGating: "MARKETPLACE_ACCOUNT_GROUP_GATING",
  },
  customEvents: {
    sessionUpdate: "sessionUpdate",
    sessionUnauthorized: "sessionUnauthorized",
    registerSuccess: "registerSuccess",
    loginSuccess: "loginSuccess",
    purchaseSuccess: "purchaseSuccess",
    userLogout: "userLogout",
    loginApiSuccess: "loginApiSuccess",
  },
  vendorUUIDs: {
    ticketmaster: "TM",
    ticketsdotcom: "TDC",
    stripe: "STRIPE",
    seatgeek: "SEATGEEK",
  },
  // Request headers sent by the MLB Ballpark App on the initial deep-link render.
  mlbBallparkHeaders: {
    oktaId: "x-bp-uid",
    email: "x-mlbam-mai",
  },
};
